<script setup>
import axios from "axios";
import { onMounted, ref } from "vue";

const table_data = ref([]);

const months = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
const selected_fitter = ref()

const fetchFittersStatistics = async () => {
  const response = await axios.get(`fitter_stats_table/`);
  table_data.value = response.data;
};
const getMonthCount = (monthsData, targetMonth) => {
  const monthData = monthsData.find((m) => m.month === targetMonth);
  return monthData ? monthData.count : '-';
};
onMounted(() => {
  fetchFittersStatistics();
});
</script>

<template>
  <!-- Dropdown to select a fitter -->
  <div class="row align-items-center mb-3">
    <div class="col-12 col-md-2">
      <p class="mb-1 fw-bold">Монтер:</p>
    </div>
    <div class="col-12 col-md-6">
      <select v-model="selected_fitter" class="form-select form-select-sm">
        <option :value="null" disabled>Выберите монтёра</option>
        <option v-for="fitter in table_data" :key="fitter.fitter_id" :value="fitter">
          {{ fitter.fitter_name }}
        </option>
      </select>
    </div>
  </div>

  <!-- Display selected fitter's data -->
  <div v-if="selected_fitter">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Год</th>
          <th v-for="(month, index) in months" :key="index">{{ month }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="yearData in selected_fitter.nested_data" :key="yearData.year">
          <th>{{ yearData.year }}</th>
          <td v-for="index in 12" :key="index">
            {{ getMonthCount(yearData.months, index) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<style scoped>
/* Add your styles here */
</style>